<div [attr.data-cy]="createDataCy(sectionTitle)" class="settlement-detail-section-title">{{sectionTitle}}</div>
